import { Box, Flex, Text } from "@chakra-ui/react";

export type CustomerChipProps = {
  cxId: string;
  customerName?: string;
  searchQuery?: string;
  isPendingRemoval?: boolean;
  isPendingAddition?: boolean;
  onClick?: () => void;
};

function HighlightedText({ text, highlight }: { text: string; highlight: string }) {
  if (!highlight.trim()) {
    return <>{text}</>;
  }

  const query = highlight.toLowerCase();
  const lowerText = text.toLowerCase();
  const startIndex = lowerText.indexOf(query);

  if (startIndex === -1) {
    return <>{text}</>;
  }

  const endIndex = startIndex + query.length;
  const before = text.slice(0, startIndex);
  const match = text.slice(startIndex, endIndex);
  const after = text.slice(endIndex);

  return (
    <>
      {before}
      <Box as="span" bg="yellow.200">
        {match}
      </Box>
      {after}
    </>
  );
}

export function CustomerChip({
  cxId,
  customerName,
  searchQuery = "",
  isPendingRemoval = false,
  isPendingAddition = false,
  onClick,
}: CustomerChipProps) {
  const displayName = customerName ?? cxId;

  return (
    <Box
      bg={isPendingAddition ? "green.50" : isPendingRemoval ? "red.50" : "white"}
      borderRadius="md"
      px={3}
      py={2}
      borderWidth="1px"
      borderColor={isPendingAddition ? "green.300" : isPendingRemoval ? "red.300" : "gray.200"}
      minW="200px"
      cursor={onClick ? "pointer" : "default"}
      onClick={onClick}
      _hover={onClick ? { borderColor: "gray.400" } : undefined}
    >
      <Flex direction="column" gap={0}>
        <Text fontSize="sm" fontWeight="medium" lineHeight="short">
          <HighlightedText text={displayName} highlight={searchQuery} />
        </Text>
        <Text fontSize="xs" color="gray.500" lineHeight="short">
          <HighlightedText text={cxId} highlight={searchQuery} />
        </Text>
      </Flex>
    </Box>
  );
}
